// Actions are all about taking an app situation (some sort of pseudo event like 'bootingStarted' or 'mapClicked') as an action and committing to the app's state.
// Ideally actions should be short and sweet and we should avoid as much logic as possible.
// Avoid dispatching other actions from within actions (nesting actions).
// More complex actions should be moved into a separate handler file.
// Shared behaviour can be abstracted into a helper function.

import {
    setEverythingLoaded,
    addLoadingItem,
    clearMapBounds,
    removeLoadingItem,
    setAuxMinimized,
    setAuxResourceUrl,
    setBootProgress,
    setExperienceMarkersLoaded,
    setFooterOpen, setInitializing,
    setModal, setNavOpen,
    setInitializingFailed, setNavLoaded
} from "./actions/helpers/commit_helpers";

import {closeAux} from "./actions/helpers/aux_helpers";
import {requestNavClose} from "./actions/helpers/nav_helpers";

import navOptionClicked from "./actions/handlers/nav_option_clicked";
import filterRouteRequested from "./actions/handlers/filter_route_requested";
import subpageRouteRequested from "./actions/handlers/subpage_route_requested";
import filterExperienceRouteRequested from "./actions/handlers/filter_experience_route_requested";
import experienceMarkerSelected from "./actions/handlers/experience_marker_selected";
import mapClicked from "./actions/handlers/map_clicked";
import subMarkerClicked from "./actions/handlers/sub_marker_clicked";
import selectNavOptionWhenReturningToMapFilter from "./actions/handlers/select_nav_option_when_returning_to_map_filter";
import mapOverlaySelected from "./actions/handlers/map_overlay_selected";

import { initFromPersistentStore } from "../../../../lib/mixins/persistable";

export default {
    initFromPersistentStore,

    initializationEnded(sm) {
        setInitializing(sm, false);
    },

    subpageRouteRequested,
    filterRouteRequested,
    filterExperienceRouteRequested,

    updateBootProgress(sm, progressPortion) {
        setBootProgress(sm, progressPortion);
    },

    loadResourcesStarted(sm) {
        setEverythingLoaded(sm, false);
    },

    loadResourcesFailed(sm) {
        setEverythingLoaded(sm, false);
        setInitializingFailed(sm, true);
    },

    loadResourcesEnded(sm) {
        setEverythingLoaded(sm, true);
    },

    loadMapLibsStarted(sm) {
        addLoadingItem(sm, {id: 'MAP_LIBS', label: 'map'});
    },

    loadMapLibsEnded(sm) {
        removeLoadingItem(sm, {id:'MAP_LIBS', label: 'map'});
    },

    loadMarkersStarted(sm) {
        addLoadingItem(sm, {id: 'MARKERS', label: 'markers'});
    },

    loadMarkersEnded(sm) {
        removeLoadingItem(sm, { id: 'MARKERS', label: 'markers' });
    },

    loadNavStarted(sm) {
        addLoadingItem(sm, { id: 'NAV', label: 'filters' });
    },

    loadNavEnded(sm) {
        removeLoadingItem(sm, { id: 'NAV', label: 'filters' });
    },

    navLoaded(sm) {
        setNavLoaded(sm, true);
    },

    navLoadFailed(sm) {
        setNavLoaded(sm, false);
        setInitializingFailed(sm, true);
    },

    viewportModal(sm, modeCode) {
        setModal(sm, modeCode);
    },

    experienceMarkersLoaded(sm) {
        setExperienceMarkersLoaded(sm, true);
    },

    experienceMarkersLoadFailed(sm) {
        setExperienceMarkersLoaded(sm, false);
        setInitializingFailed(sm, true);
    },

    subPageRequested(sm, url) {
        setAuxResourceUrl(sm, url);
    },

    // Reflect the Nav webview's authoritative open/close into the online_app's navOpen mirror
    // (plan 2026-07-15). This is the ONLY writer of navOpen in the online_app SM — the map/nav
    // interactions below no longer set it directly, they request a change of the Nav (which then
    // emits the signal that lands here). Dispatched by online_app_nav.js's reflection listeners.
    navOpenReflected(sm, open) {
        setNavOpen(sm, open);
    },

    navOptionClicked,

    selectNavOptionWhenReturningToMapFilter,

    auxClosed(sm) {
        closeAux(sm);
    },

    auxScrolledOff(sm) {
        setAuxMinimized(sm, true);
    },

    auxScrolledOn(sm) {
        setAuxMinimized(sm, false);
    },

    mapOverlaySelected,

    mapClicked,

    mapDragged(sm) {
        clearMapBounds(sm);
        requestNavClose(); // Request the Nav to close (it owns navOpen); the reflection lands as navOpenReflected.
    },

    clusterSelected(sm, cluster) {
        console.log('clusterSelected', cluster);
    },

    experienceMarkerSelected,

    subMarkerClicked,

    auxHeaderCloserSelected(sm, auxHeaderCloser) {
        closeAux(sm, auxHeaderCloser);
    },

    footerCloserSelected(sm, footerCloser) {
        setFooterOpen(sm, false);
        setTimeout(()=> { footerCloser.destroyFooter() },5000);
    },

    initialFooterViewing(sm, isOpen) {
        setFooterOpen(sm, isOpen)
    },

    initialHeaderViewing(sm, isOpen) {
        setHeaderOpen(sm, isOpen)
    },

};

